export default __webpack_public_path__ + "static/media/cain.f2aa8606.png";